export const APPLICATION_NAME = '@ori/top-area';
export const CN_MARKET = 'cn';
export const CONSULTANT_NUMBER_QUERY_PARAM_KEY = 'chPwdUsr';
export const DESKTOP_BREAKPOINT = 1024;
export const RETURN_URL_QUERY_PARAM_KEY = 'returnUrl';
export const SCROLL_THROTTLE_DELAY = 100;

// Temporary (few months) solution, will be removed in future
export const TENANTS_LIST_WHERE_CATALOG_HEADER_IS_HIDDEN = [
  'ks',
  'bg',
  'si',
  'hr',
  'rs',
  'bg',
  'ba',
  'ee',
  'lv',
  'lt',
  'ma',
];

// Google Analytics base not changing meta hierarchy
export const CLICK_CATALGOUE = ['open_ecatalogue', 'Main menu sidebar'];
export const CLICK_CATALOGUE_DETAIL = ['open_ecatalogue', 'Main menu content'];
export const CLICK_BURGER_MENU = ['open_main_menu', 'Top navigation'];
export const CLICK_CATEGORY_BRAND = ['select_brand', 'Main menu content'];
export const START_SEARCH = ['search_start', 'Search 1'];
export const SEARCH_THROTTLE_TIME = 1000 * 60 * 5;
export const CATALOG_LINK_TYPE = 'Catalogue';
export const CLICK_FAVORITE_ICON = ['open_favorites', 'Top navigation'];
export const CLICK_NOTIFICATION_ICON = ['open_notifications', 'Top navigation'];
export const ROBOTO_FONT_URL = 'https://fonts.googleapis.com/css?family=Roboto:400&display=swap';

export const TOP_NAV_HEIGHT = 80;
export const TOP_NAV_HEIGHT_SHRUNK = 60;
export const TOP_NAV_HEIGHT_MOBILE = 56;

/**
 * Identity server client ID for authentication.
 */
export const IDENTITY_CLIENT_ID = 'SPADev';
